import type { MetricItem } from '../../../config/mockDashboardData';
import styles from '../../dashboard/Dashboard.module.scss';

interface AnalyticsMetricCardProps {
  metric: MetricItem;
}

const getTrendClass = (change: number, higherIsBetter = true) => {
  if (change === 0) return styles.metricTrendNeutral;
  const isPositiveTrend = higherIsBetter ? change > 0 : change < 0;
  return isPositiveTrend ? styles.metricTrendPositive : styles.metricTrendNegative;
};

const LONG_VALUE_LENGTH = 4;

export const AnalyticsMetricCard = ({ metric }: AnalyticsMetricCardProps) => {
  const change = metric.change;
  const hasChange = change !== null && change !== undefined;
  const sign = hasChange && change > 0 ? '+' : '';
  const value = String(metric.value ?? '');
  return (
    <div className={styles.metricCard}>
      <span className={styles.metricTitle}>{metric.title}</span>
      <span
        className={`${styles.metricValue} ${value.length > LONG_VALUE_LENGTH ? styles.metricValueLong : ''}`}
      >
        {metric.value}
      </span>
      <div className={styles.metricTrend}>
        <span
          className={
            hasChange ? getTrendClass(change, metric.higherIsBetter) : styles.metricTrendNeutral
          }
        >
          {hasChange ? `${sign}${change}%` : '—'}
        </span>
        <span className={styles.metricTrendLabel}>vs last month</span>
      </div>
    </div>
  );
};

export const AnalyticsMetricsGrid = ({
  metrics,
  columns = 4,
}: {
  metrics: MetricItem[];
  columns?: 3 | 4 | 5 | 6;
}) => {
  const gridClass =
    columns === 6
      ? styles.metricsGridSix
      : columns === 5
        ? styles.metricsGridFive
        : columns === 3
          ? styles.metricsGridThree
          : styles.metricsGrid;

  return (
    <div className={gridClass}>
      {metrics.map((metric) => (
        <AnalyticsMetricCard key={metric.id} metric={metric} />
      ))}
    </div>
  );
};
